<template>
  <div class="loading"><span class="blind">로딩중</span></div>
</template>
<script>
export default {
}
</script>